export function AssignErrorTextHandler(src: any, dest: any): void {
  if (src.errorText) {
    dest.event.eventDescription[0].errorText = src.errorText;
  } else if (src.errorMessage) {
    dest.event.eventDescription[0].errorText = src.errorMessage.userMessage;
    dest.event.eventDescription[0].errorCode = src.errorMessage.code;
  }
}
